import React from "react";
import { motion } from "framer-motion";

// Courses / Certifications Data
const courses = [
  {
    title: "AWS Cloud Technical Essentials",
    issuer: "Coursera",
    issued: "May 2023",
    credentialId: "53DVV4A2YU7U",
    skills: ["MySQL", "Python"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Advanced React",
    issuer: "Coursera",
    issued: "Apr 2023",
    credentialId: "WVGVVZMPSSE7",
    skills: ["JavaScript", "React.js"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "HTML and CSS in Depth",
    issuer: "Coursera",
    issued: "Apr 2023",
    credentialId: "8Q4XW44GEWWM",
    skills: ["HTML", "CSS"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Principles of UX/UI Design",
    issuer: "Coursera",
    issued: "Apr 2023",
    credentialId: "RTQSAZQKS5TC",
    skills: ["UX", "UI", "Design"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Programming with JavaScript",
    issuer: "Coursera",
    issued: "Mar 2023",
    credentialId: "DBS77NBLLJ97",
    skills: ["JavaScript", "React.js", "MySQL"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "React Basics",
    issuer: "Coursera",
    issued: "Mar 2023",
    credentialId: "3GCY7PBJNC2J",
    skills: ["JavaScript", "React.js"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Version Control",
    issuer: "Coursera",
    issued: "Mar 2023",
    credentialId: "V45UBLWJQW9X",
    skills: ["Python"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Introduction to Front-End Development",
    issuer: "Coursera",
    issued: "Feb 2023",
    credentialId: "7SFZAMZVD2Q5",
    skills: ["MySQL"],
    logo: require('../assets/Courses/1.png'),
  },
  {
    title: "Building and Evaluating Advanced RAG",
    issuer: "DeepLearning.AI",
    issued: "",
    credentialId: "",
    skills: [],
    logo: require('../assets/Courses/2.jpg'),
  },
];

const CoursesSection = () => {
  return (
    <section id="courses" className="courses-section text-gray-300 py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
          Courses & Certifications
        </h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {courses.map((course, index) => (
            <motion.div
              key={index}
              className="bg-black/70 p-4 md:p-6 rounded-xl border border-gray-800 shadow-lg cursor-pointer hover:shadow-xl transition-shadow flex flex-col"
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.3 }}
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={course.logo}
                  alt={course.issuer}
                  className="w-10 h-10 object-contain rounded-md"
                />
                <h3 className="text-lg md:text-xl font-semibold text-white">{course.title}</h3>
              </div>
              <p className="text-gray-400 text-sm mb-1">
                {course.issuer} {course.issued && `· Issued ${course.issued}`}
              </p>
              {course.credentialId && (
                <p className="text-gray-500 text-xs mb-2">Credential ID: {course.credentialId}</p>
              )}
              {course.skills.length > 0 && (
                <ul className="flex flex-wrap gap-2 mt-auto">
                  {course.skills.map((skill, i) => (
                    <li
                      key={i}
                      className="bg-blue-500 text-black text-xs font-medium px-2 py-1 rounded"
                    >
                      {skill}
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CoursesSection;
